import { Icon } from 'office-ui-fabric-react';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { caption2Font } from '../Typography/Typography';

export interface IPillButtonProps {
  ariaLabel: string;
  /**
   * By default the Pill Button will use the Add icon when not selected.
   * When selected, the Pill Button will use the checkmark when not hovered, and the cancel icon on hover.
   * This can be overridden by setting iconName and hoverIconName.
   * If iconName is set but hoverIconName is not set, the iconName icon will be displayed
   * on both hover and not hover states.
   */
  iconName?: string;
  hoverIconName?: string;
  disabled?: boolean;
  className?: string;
  isSelected?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const PillStyleButton = styled.button`
  text-align: left;
  font-weight: normal;
  cursor: pointer;
  color: rgb(0, 0, 0);
  ${caption2Font}
  font-weight: 400;
  display: flex;
  border-radius: 30px;
  padding: 0px 8px;
  background: rgb(210, 210, 210);
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
  height: 25px;
  outline-width: 0;

  .hover-only {
    display: none;
  }

  &.selected {
    background: #243a5e;
    color: white;
  }

  &:focus,
  &:hover,
  &:active,
  &.hover {
    color: white;
    background-color: rgb(0, 120, 212);
    .hover-only {
      display: inline;
    }
    .static-only {
      display: none;
    }
  }
  :disabled {
    background: #243a5e;
    color: #ffffff;
    cursor: unset;
  }
`;

const StyledText = styled.span`
  padding: 0 0 1px 0;
`;

const StyledIcon = styled(Icon)`
  margin: 0px 4px;
  ${caption2Font}
  padding: 3px 0 1px 2px;
`;

export const PillButton: FunctionComponent<IPillButtonProps> = ({
  children,
  ariaLabel,
  disabled,
  className,
  onClick,
  iconName,
  hoverIconName,
  isSelected,
}) => {
  if (iconName !== undefined) {
    if (!hoverIconName) hoverIconName = iconName;
  } else {
    iconName = isSelected ? 'CheckMark' : 'Add';
    hoverIconName = isSelected ? 'Cancel' : 'Add';
  }

  return (
    <PillStyleButton
      aria-label={ariaLabel}
      onClick={onClick}
      className={`${className} ${isSelected ? 'selected' : ''}`}
      disabled={disabled}
    >
      <StyledText>{children}</StyledText>
      <StyledIcon className="static-only" iconName={iconName} />
      <StyledIcon className="hover-only" iconName={hoverIconName} />
    </PillStyleButton>
  );
};

export default PillButton;
